import { render, staticRenderFns } from "./FormToggle.vue?vue&type=template&id=bce7c1ce&"
import script from "./FormToggle.vue?vue&type=script&lang=js&"
export * from "./FormToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports